export default "__VITE_ASSET__BOYjg9cg__"